/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListItemFieldValueDto
 */
export interface WebApiCustomListsDtoCustomListItemFieldValueDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemFieldValueDto
     */
    fieldId?: number;
    /**
     * 
     * @type {any}
     * @memberof WebApiCustomListsDtoCustomListItemFieldValueDto
     */
    fieldValue?: any | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListItemFieldValueDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListItemFieldValueDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON(json: any): WebApiCustomListsDtoCustomListItemFieldValueDto {
    return WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListItemFieldValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'fieldValue': !exists(json, 'fieldValue') ? undefined : json['fieldValue'],
    };
}

export function WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON(value?: WebApiCustomListsDtoCustomListItemFieldValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldId': value.fieldId,
        'fieldValue': value.fieldValue,
    };
}

